module.exports = __webpack_public_path__ + "static/media/google.2776ad8b.png";